import { snack } from '@alixpartners/ui-components';
import { uniqueId } from 'lodash';
import { ReactChild } from 'react';
import { SnackSuccessfulBody } from './Body/SnackSuccessfulBody';
import { SnackWarningBody } from './Body/SnackWarningBody';

interface Props {
  title?: string;
  message?: ReactChild;
}

export const snackInfoSuccessful = ({ title, message }: Props) => {
  snack.custom({
    id: uniqueId('snack-successful-notification-'),
    position: 'top-right',
    custom: () => <SnackSuccessfulBody title={title} message={message} />,
  });
};

export const snackInfoWarning = ({ title, message }: Props) => {
  snack.custom({
    id: uniqueId('snack-warning-notification-'),
    position: 'top-right',
    custom: () => <SnackWarningBody title={title} message={message} />,
  });
};
